var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preloader"},[_c('half-circle-spinner',{attrs:{"animation-duration":1000,"size":60,"color":"rgb(101, 91, 94)"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }